import { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { Box, Flex, Heading, Text } from "@chakra-ui/react";

import ProductCard from "../ProductCard/ProductCard";
import { Pagination } from "../Pagination/Pagination";
import { ExportCSV } from "../ExportCSV/ExportCSV";

import { Product } from "../../interface/interface";
import { fetchProducts } from "../../services/api";

const ProductList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [lastSyncDate, setLastSyncDate] = useState<Date | null>(new Date());

  const { data: products, refetch } = useQuery(
    ["products", currentPage],
    () => fetchProducts(currentPage),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const syncInterval = setInterval(() => {
      refetch();
      setLastSyncDate(new Date());
    }, 5 * 60 * 1000); // Refresh every 5 minutes

    return () => {
      clearInterval(syncInterval);
    };
  }, [refetch]);

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="center">
        <Heading paddingLeft="3">TOYS</Heading>
        <ExportCSV products={products?.data} />
      </Flex>
      <Text textAlign="center" fontWeight="extrabold" color="gray.500" mt={6}>
        Last Sync: {lastSyncDate?.toLocaleString()}
      </Text>
      <Flex flexWrap="wrap" mt={4}>
        {Array.isArray(products?.data) ? (
          products?.data.map((product: Product) => (
            <ProductCard
              key={product.id}
              name={product.name}
              price={product.price}
              image={product.image}
              rating={product.rating}
              isSale={product.is_sale}
              actualPrice={product.special_price}
            />
          ))
        ) : (
          <Text>No products found</Text>
        )}
      </Flex>
      <Pagination
        currentPage={currentPage}
        totalPages={Math.ceil(products?.pageCount / 10) || 1} // Assuming 10 products per page
        onPageChange={handlePageChange}
      />
    </Box>
  );
};

export { ProductList };
